import React from 'react';
import { Award, GraduationCap, Heart } from 'lucide-react';
export function PhysicianProfile() {
  return <div className="min-h-screen bg-gradient-to-b from-white to-[#f8faff] dark:from-[#0a0e17] dark:to-[#111827]" data-id="element-655">
      {/* Hero Section */}
      <section className="pt-32 pb-16 px-6" data-id="element-656">
        <div className="container mx-auto max-w-6xl" data-id="element-657">
          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-658">
            {/* Image */}
            <div className="flex justify-center" data-id="element-659">
              <div className="relative" data-id="element-660">
                <div className="absolute inset-0 bg-gradient-to-r from-[#BBDDFF] to-[#C85A15] rounded-2xl blur-2xl opacity-20" data-id="element-661"></div>
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/4tNwEXNv93vUJ7oNGHnyhv/Dr._Patel_Image.jpg" alt="Dr. Manharkumar Patel" className="relative rounded-2xl shadow-2xl w-full max-w-md" data-id="element-662" />
              </div>
            </div>

            {/* Info */}
            <div data-id="element-663">
              <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-664">
                <span className="bg-gradient-to-r from-[#BBDDFF] to-[#C85A15] bg-clip-text text-transparent" data-id="element-665">
                  Dr. Manharkumar Patel, MD
                </span>
              </h1>
              <p className="text-xl text-gray-600 dark:text-gray-300 mb-6" data-id="element-666">
                Board Certified Family Medicine & Obesity Medicine Physician
              </p>
              <div className="flex items-center gap-2 text-gray-600 dark:text-gray-400 mb-8" data-id="element-667">
                <Heart className="text-[#C85A15]" size={20} data-id="element-668" />
                <span data-id="element-669">Dedicated to personalized, compassionate care</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Bio Section */}
      <section className="py-16 px-6" data-id="element-670">
        <div className="container mx-auto max-w-4xl" data-id="element-671">
          <div className="bg-white dark:bg-gray-800/80 backdrop-blur-sm rounded-2xl p-10 shadow-xl border border-white/20 dark:border-gray-700/30" data-id="element-672">
            <div className="flex items-center gap-3 mb-6" data-id="element-673">
              <div className="w-12 h-12 rounded-full bg-[#C85A15]/20 flex items-center justify-center" data-id="element-674">
                <Heart className="text-[#C85A15]" size={24} data-id="element-675" />
              </div>
              <h2 className="text-3xl font-bold" data-id="element-676">About Dr. Patel</h2>
            </div>
            <div className="space-y-4 text-gray-600 dark:text-gray-300 text-lg leading-relaxed" data-id="element-677">
              <p data-id="element-678">
                Dr. Manharkumar Patel, MD grew up in India and completed his
                Family Medicine training in California. He is a proud husband
                and father who enjoys traveling with his family and exploring
                different cultures around the world.
              </p>
              <p data-id="element-679">
                Dr. Patel is dedicated to creating a safe and supportive
                environment for his patients. He takes the time to listen,
                understand their concerns, and work collaboratively to develop
                personalized treatment plans that fit each individual's needs.
              </p>
            </div>
          </div>

          {/* Certifications Section */}
          <div className="bg-white dark:bg-gray-800/80 backdrop-blur-sm rounded-2xl p-10 shadow-xl border border-white/20 dark:border-gray-700/30 mt-8" data-id="element-680">
            <div className="flex items-center gap-3 mb-8" data-id="element-681">
              <div className="w-12 h-12 rounded-full bg-[#BBDDFF]/20 flex items-center justify-center" data-id="element-682">
                <Award className="text-[#BBDDFF]" size={24} data-id="element-683" />
              </div>
              <h2 className="text-3xl font-bold" data-id="element-684">Board Certifications</h2>
            </div>
            <div className="grid md:grid-cols-2 gap-6" data-id="element-685">
              <div className="flex items-start gap-3" data-id="element-686">
                <Award className="text-[#C85A15] flex-shrink-0 mt-1" size={20} data-id="element-687" />
                <div data-id="element-688">
                  <h3 className="font-semibold mb-1" data-id="element-689">Board Certified</h3>
                  <p className="text-gray-600 dark:text-gray-300" data-id="element-690">
                    American Board of Family Medicine (ABFM)
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3" data-id="element-691">
                <Award className="text-[#C85A15] flex-shrink-0 mt-1" size={20} data-id="element-692" />
                <div data-id="element-693">
                  <h3 className="font-semibold mb-1" data-id="element-694">Diplomate</h3>
                  <p className="text-gray-600 dark:text-gray-300" data-id="element-695">
                    American Board of Obesity Medicine (ABOM)
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3" data-id="element-696">
                <Award className="text-[#C85A15] flex-shrink-0 mt-1" size={20} data-id="element-697" />
                <div data-id="element-698">
                  <h3 className="font-semibold mb-1" data-id="element-699">ECFMG Certified</h3>
                  <p className="text-gray-600 dark:text-gray-300" data-id="element-700">
                    Educational Commission for Foreign Medical Graduates
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Health Information Credentials */}
          <div className="bg-white dark:bg-gray-800/80 backdrop-blur-sm rounded-2xl p-10 shadow-xl border border-white/20 dark:border-gray-700/30 mt-8" data-id="element-701">
            <div className="flex items-center gap-3 mb-8" data-id="element-702">
              <div className="w-12 h-12 rounded-full bg-[#BBDDFF]/20 flex items-center justify-center" data-id="element-703">
                <GraduationCap className="text-[#BBDDFF]" size={24} data-id="element-704" />
              </div>
              <h2 className="text-3xl font-bold" data-id="element-705">
                Health Information Credentials
              </h2>
            </div>
            <div className="flex flex-wrap gap-4" data-id="element-706">
              <span className="bg-gradient-to-r from-[#BBDDFF]/20 to-[#C85A15]/20 px-4 py-2 rounded-full font-semibold" data-id="element-707">
                RHIA
              </span>
              <span className="bg-gradient-to-r from-[#BBDDFF]/20 to-[#C85A15]/20 px-4 py-2 rounded-full font-semibold" data-id="element-708">
                CCDS
              </span>
              <span className="bg-gradient-to-r from-[#BBDDFF]/20 to-[#C85A15]/20 px-4 py-2 rounded-full font-semibold" data-id="element-709">
                CCS
              </span>
              <span className="bg-gradient-to-r from-[#BBDDFF]/20 to-[#C85A15]/20 px-4 py-2 rounded-full font-semibold" data-id="element-710">
                CDIP
              </span>
            </div>
          </div>

          {/* Professional Memberships */}
          <div className="bg-white dark:bg-gray-800/80 backdrop-blur-sm rounded-2xl p-10 shadow-xl border border-white/20 dark:border-gray-700/30 mt-8" data-id="element-711">
            <div className="flex items-center gap-3 mb-8" data-id="element-712">
              <div className="w-12 h-12 rounded-full bg-[#BBDDFF]/20 flex items-center justify-center" data-id="element-713">
                <GraduationCap className="text-[#BBDDFF]" size={24} data-id="element-714" />
              </div>
              <h2 className="text-3xl font-bold" data-id="element-715">Professional Memberships</h2>
            </div>
            <div className="space-y-4" data-id="element-716">
              <div className="flex items-center gap-3" data-id="element-717">
                <div className="w-2 h-2 rounded-full bg-[#C85A15]" data-id="element-718"></div>
                <p className="text-gray-600 dark:text-gray-300" data-id="element-719">
                  <span className="font-semibold" data-id="element-720">AHIMA</span> – American Health
                  Information Management Association (2014–Present)
                </p>
              </div>
              <div className="flex items-center gap-3" data-id="element-721">
                <div className="w-2 h-2 rounded-full bg-[#C85A15]" data-id="element-722"></div>
                <p className="text-gray-600 dark:text-gray-300" data-id="element-723">
                  <span className="font-semibold" data-id="element-724">AAFP</span> – American Academy
                  of Family Physicians
                </p>
              </div>
            </div>
          </div>

          {/* Licensed States */}
          <div className="bg-white dark:bg-gray-800/80 backdrop-blur-sm rounded-2xl p-10 shadow-xl border border-white/20 dark:border-gray-700/30 mt-8" data-id="element-725">
            <div className="flex items-center gap-3 mb-8" data-id="element-726">
              <div className="w-12 h-12 rounded-full bg-[#C85A15]/20 flex items-center justify-center" data-id="element-727">
                <Award className="text-[#C85A15]" size={24} data-id="element-728" />
              </div>
              <h2 className="text-3xl font-bold" data-id="element-729">Licensed in 30 States</h2>
            </div>
            <div className="flex flex-wrap gap-3" data-id="element-730">
              {['AL', 'AZ', 'CA', 'CO', 'DE', 'FL', 'GA', 'IA', 'ID', 'IL', 'IN', 'KS', 'KY', 'LA', 'MD', 'MI', 'MN', 'MO', 'MS', 'NJ', 'NV', 'OH', 'OK', 'PA', 'TN', 'TX', 'UT', 'WA', 'WI', 'WV'].map(state => <span key={state} className="bg-gradient-to-r from-[#BBDDFF]/20 to-[#C85A15]/20 px-4 py-2 rounded-full font-semibold" data-id="element-731">
                  {state}
                </span>)}
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 px-6" data-id="element-732">
        <div className="container mx-auto max-w-4xl text-center" data-id="element-733">
          <div className="bg-gradient-to-r from-[#BBDDFF]/10 to-[#C85A15]/10 rounded-2xl p-12 border border-white/20 dark:border-gray-700/30" data-id="element-734">
            <h2 className="text-3xl font-bold mb-4" data-id="element-735">
              Ready to Start Your Journey?
            </h2>
            <p className="text-lg text-gray-600 dark:text-gray-300 mb-8" data-id="element-736">
              Dr. Patel is here to support you with personalized care tailored
              to your needs.
            </p>
            <a href="https://staging.joinomu.com/patient/onboarding" target="_blank" rel="noopener noreferrer" className="inline-flex items-center bg-gradient-to-r from-[#C85A15] to-[#FF8A3D] text-white font-medium py-3 px-8 rounded-full hover:shadow-lg transition-all" data-id="element-737">
              Get Started Today
            </a>
          </div>
        </div>
      </section>
    </div>;
}